export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_Alexa-32049cab3d56e9c606ff1ce4f967cb9d.webp";